import React from 'react';
import { SensorCard } from './SensorCard';
import { useProctor } from '../../context/ProctorContext';

const SENSOR_DEFS = [
  { key: 'gaze' as const,     name: '시선+헤드포즈', metric: '편차 (°)' },
  { key: 'keyboard' as const, name: '키보드',        metric: '타이핑 속도' },
  { key: 'voice' as const,    name: '음성',          metric: '발화 점유율' },
  { key: 'stylus' as const,   name: '필기',          metric: '필압 / 속도' },
  { key: 'body' as const,     name: '자세',          metric: '어깨 기울기' },
  { key: 'focus' as const,    name: '집중도',        metric: '포커스 점수' },
];

export function SensorCardsRow() {
  const { sensorValues } = useProctor();

  return (
    <div className="sensors-row">
      {SENSOR_DEFS.map(def => (
        <SensorCard
          key={def.key}
          name={def.name}
          metric={def.metric}
          value={sensorValues[def.key].value}
          zScore={sensorValues[def.key].zScore}
          active={sensorValues[def.key].active}
        />
      ))}
    </div>
  );
}
